import { useContext } from 'react';
import { CopyViewModalContext } from '../contexts/CopyViewModalContext';

export const useCopyViewModal = () => {
  const context = useContext(CopyViewModalContext);

  if (context === undefined) {
    throw new Error(
      'useCopyViewModal must be used within a CopyViewModalContext',
    );
  }
  return context;
};
